<template>
    <ul id="list-tasks">
      <li>
        <!-- pc view -->
        <div id='oblea' style="min-height: 135px;" v-if='!mobileView'>
          <div id='s1'>
            <img id="imagenProducto" :src="imagenProducto" style="width: 85%; height: 85%; object-fit: contain; margin-top: 10px"  v-show='imagenProducto != null'/> 
          </div> 
          <div class="fv lc" style="width: 65%; height: 100%;">
            <p style="font-size: 14px; color: #656E76; margin-top: 8px; font-weight: 500">{{item.Nombre}}</p>
            <p style="font-size: 9px; color: #656E76; margin-top: 2px; height: 7px">{{item.Observacion}}</p>
            <p style="font-size: 10px; color: #656E76; font-weight: bold; margin-top: 12px"> Contenido: </p>
            <div style="margin-left: 5px; margin-top: 2px; font-size: 10px; color: #656E76; font-weight: normal; height: 40px; overflow: auto;">
                <ul>
                    <li v-for="producto in productos">{{ producto }}</li>
                </ul>
            </div>
            <div class="fh cc" style="width: 100%; height:100%; margin-top: 15px; margin-bottom: 10px">
                <div class="fh cc" style="width: 50%; height:100%; font-size: 10px; color: #656E76; font-weight: bold;">Precio Habitual: ${{getPrecioHabitual | formatMoney}}</div> 
                <div class="fh cc" style="width: 50%; height:100%; font-size: 10px; color: #656E76; font-weight: bold;">Precio Promocional: ${{getPrecioPromocional | formatMoney}}</div>
            </div>
          </div> 
          <div id='s3' style="margin-top: 45px">
            <button id="btnAgregar" @click="btnAgregar">AGREGAR</button>
          </div> 
        </div>
        <!-- mobile view -->
        <div  v-if='mobileView' class="oblea-mobile" style="width: 90vw; padding-top: 10px; padding-bottom: 10px; display: flex; flex-direction: row; align-items: flex-start; justify-content: flex-start;">
          <div class="fh cc" style="width: 30%; height: 100%;">
            <img id="imagenProducto" :src="imagenProducto" style="width: 80%; height: 80%; object-fit: contain"/> 
          </div>
          <div class="fv lc" style="width: 55%; height: 100%;">
            <div class="fh cc" style="margin-left: 10px; font-size: 16px; color:#5D6770; font-weight: 500">{{item.Nombre}}</div>
            <div class="fh cc" style="margin-left: 10px; font-size: 9px; color:#5D6770; font-weight: 400; margin-top: 5px">{{item.Observacion}}</div>
            <div class="fh cc" style="margin-left: 10px; font-size: 11px; color:#5D6770; margin-top: 10px">Precio Habitual: ${{getPrecioHabitual | formatMoney}}</div>
            <div class="fh cc" style="margin-left: 10px; font-size: 11px; color:#5D6770; margin-top: 2px; font-weight: 500">Precio Promo: ${{getPrecioPromocional | formatMoney}}</div>
          </div>
          <div class="fh cc" style="width: 15%; height: 100%;">
            <img src="/dist/carrito-gris.svg" style="height: 20px" @click="btnAgregar"/> 
          </div>
        </div>
      </li>
    </ul>
  </template>
  
   
  <script>
    import axios from 'axios'
  
    
    export default {
      name: 'item-promocion',
      props: ['item'],
  
      data() {
        return {
           mobileView:false,
           productos: []
        }
      },  
  
      watch: {
        item: {
          immediate: true,
          handler  () {
          }
        }
      },

      computed: {

        getPrecioHabitual () {
          this.item.Productos.forEach((p)=> {
            var prod = this.$store.state.pedido.productos.find((it) =>  {return it.Id == p.ProductoId});
            if (prod) {
              this.productos.push(p.Cantidad + ' x   ' + prod.Categorizacion2Nombre + ' / ' + prod.Nombre)
            }
          });
          return this.item.PrecioHabitual.toFixed(2);
        },

        getPrecioPromocional () {
          return this.item.PrecioPromocional.toFixed(2);
        },

        imagenProducto() {
          if (this.item.ImagenesUrl.length > 0) {
            return this.item.ImagenesUrl[0]
          }
          else {
            return '/dist/placeholder-producto.png'
          }
        },  

      },
  
      methods: {

        onResize() {
          if (window.innerWidth > 600) 
          {
            this.mobileView=false;
          }
          else 
          {
            this.mobileView=true;
          }
        },

        btnAgregar () {
          this.$emit('setItemPromocion', this.item.Id);
         },

      },

    mounted() {
      this.onResize()
    },

    created() {
      window.addEventListener('resize', this.onResize)
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.onResize)
    }
  
  }
  </script>
  
  
  <style scoped>
  
  * {
    margin:  0;
    padding: 0;
  }


  #oblea {
    width: 630px;
    margin-bottom: 10px;
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border: 1px solid #dddddd;
    box-shadow: 1px 1px 2px #dddddd;
    display: flex;
    align-items: flex-start; 
  }
 

 .oblea-mobile {
    width: 90vw;
    /* height:100px; */
    margin-bottom: 10px;
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border: 1px solid #dddddd;
    box-shadow: 1px 1px 2px #dddddd;
    display: flex;
    flex-direction: row;
    align-items: flex-start; 
    justify-content: flex-start;
  }



  #s1{
  width: 17%;
  height: 100%;
  background: #ffffff;  
  display: flex;
  justify-content: center;  
  align-items: center;  
  }
  
  #s2{
    width: 65%;
    height: 100%;
    background: #ffffff;  
  }
  
  #s3{
    width: 18%;
    height: 100%;
    background: #ffffff;  
    display: flex;
    justify-content: center;  
    align-items: center;  
  }
  
  
  
  .label{
    font-size: 10px;
    color: #656E76;
    font-weight: bold;
    background-color: #ffffff;
    width: 90px;
    float: left;
  }
  
  .value{
    font-size: 10px;
    font-weight: bold;  
    color: #656E76;
    width: 70px;
    background-color: #ffffff;
    float: left;
  }
  
  #label-subtotal{
    font-size: 10px;
    font-weight: bold;
    color: #656E76;
    margin-left: 10%;
    width: 110px;
    background-color: #ffffff;
    float: left;
  }
  

  #btnAgregar{
    width: 85px;
    height: 22px;
    font-size: 7px;
    border-style: solid;
    border:none; 
    background: #44C7F4; 
    border-radius: 20px;  
    color: #ffffff;
    outline: none;
  }
            
  #btnAgregar:hover { cursor: pointer; }
  
 </style>


// WEBPACK FOOTER //
// src/components/views/promociones/itemPromociones.vue